module.exports = __webpack_public_path__ + "img/箭头 (1).a3ab5997.png";